import type { ReactNode } from 'react';

import { CountryFlag } from '@/shared/ui';
import type { ProviderOption } from '@psp-aggregator/sdk';

export interface ProviderTagOption {
  icon?: ReactNode;
  label: string;
  value: string;
}

export const toProviderTagOptions = (
  options: readonly ProviderOption[] = [],
): ProviderTagOption[] =>
  options.map((option) => ({
    label: option.name,
    value: option.code,
  }));

export const toCountryTagOptions = (
  options: readonly ProviderOption[] = [],
): ProviderTagOption[] =>
  options.map((option) => ({
    icon: <CountryFlag code={option.code} />,
    label: option.name,
    value: option.code,
  }));
